<div class="row mx-0">
  <!-- validate referal code  -->
  <div>
    <div class="col-12 px-0">
      <div class="pointer-cursor position-absolute right-align z-999 m-4">
        <img src="assets/images/close-black.svg" alt="" (click)="close()" height="24" width="24">
      </div>
      <img src="assets/images/login-image.png" alt="" class="w-100">
    </div>
    <div class="col-12 px-0 body-content modal-body-scroll">
      <div class="row mx-0">
        <div class="col-12 px-0 px-lg-4 text-center signupheading">
          <p class="amatic-bold">{{'Learn sustainable goals to transform our world' | translate}}</p>
        </div>
        <div class="col-12 px-0 text-center">
          <p class="mulish-normal text-14 color-5F5F5F">
            {{'Welcome to Global expidition gaming platform.' | translate}}<br>
            {{'Please enter your username and password to continue' | translate}}</p>
        </div>
        <div class="col-12 px-0 text-left">
          <div class="login">
            <form [formGroup]="loginForm" (keyup.enter)="Login()">
              <!-- <p class="mulish-normal text-xxs color-5F5F5F">Your referral code</p>
                    <div class="referal">
                        <input type="text" id="referalcode" name="referalcode" placeholder="Referral code" class="w-100">
                    </div> -->
              <div>
                <span *ngIf="submitted" class="text-center">
                  <!-- <small *ngIf="fcontrol.username.hasError('incorrect') || fcontrol.password.hasError('incorrect')"
                    class="form-text text-danger">{{ 'Incorrect username or password' | translate }}</small> -->
                  <small *ngIf="loginError" class="form-text text-danger">
                    {{ 'Incorrect username or password' | translate }}</small>
                </span>

                <p class="text-label text-xxs mulish-normal color-5F5F5F" for="username">{{'Your username' | translate}}
                </p>
                <input type="text" class="w-100" formControlName="username" [ngClass]="{
                            'has-danger': fcontrol.username.invalid && (fcontrol.username.touched || submitted),
                            'has-success': fcontrol.username.valid}" id="username"
                  placeholder="{{'Username' | translate}}" required>
                <span *ngIf="fcontrol.username.touched && submitted">
                  <small *ngIf="fcontrol.username.invalid && fcontrol.username.value == ''" id="emailHelp"
                    class="form-text text-danger">{{ errMessage | translate }}</small>
                </span>

              </div>
              <div>
                <p class="text-label text-xxs mulish-normal color-5F5F5F" for="password">{{'Your password' | translate}}
                </p>
                <div class="position-relative">
                  <input [type]="passwordHide ? 'password' : 'text'" class="w-100 psw-input" formControlName="password"
                    [ngClass]="{
                              'has-danger': fcontrol.password.invalid && (fcontrol.password.touched || submitted),
                              'has-success': fcontrol.password.valid}" id="password" maxlength="10"
                    placeholder="{{'Password' | translate}}" required>
                  <mat-icon class="visibility-icon" matSuffix (click)="passwordHide = !passwordHide">
                    {{passwordHide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </div>
                <span *ngIf="fcontrol.password.touched && submitted">
                  <small *ngIf="fcontrol.password.invalid && fcontrol.password.value == ''" id="emailHelp"
                    class="form-text text-danger">{{ errMessage | translate }}</small>
                </span>

              </div>

              <div class="mt-3" id="forgotpass">
                <div class="d-flex">
                  <p class="mulish-normal text-14 pr-3 mb-0">{{'Forgot password?' | translate}}</p>
                  <img src="assets/images/Info-icon.svg" alt=""
                    matTooltip="{{'Please contact your group admin to reset your password!' | translate}}"
                    class="example-button mulish-normal text-14" matTooltipPosition="below">
                </div>
              </div>

            </form>

          </div>

        </div>
        <div class="col-12 px-0 mt-5">
          <div
            class="bg-danger d-flex text-13 text-white badge-custom align-items-center justify-content-center cursor-pointer mulish-bold"
            (click)="Login()">
            <span> {{'Login to your account' | translate | uppercase}} </span>
            <mat-icon class="ml-3">arrow_right_alt</mat-icon>
          </div>

        </div>
        <div class="col-12 px-0 mt-5 text-center">
          <p class="mulish-normal text-14 color-5F5F5F">{{'Didn’t have an account?' | translate}} <a (click)="gotoSignup()"
              class="signup-link font-red text-uppercase"><b>{{'Sign up using referral' | translate}}</b></a> </p>

        </div>

      </div>

    </div>
  </div>
</div>
